import    React,
       {  useState, 
          useEffect,
          useRef              }   from "react";
import    dayjs                   from "dayjs";          
import    MainStyle               from "components/UI/main.module.scss";
import {  getHomeData         }   from "./staticContentService";
import {  Cell,
          BarChart, 
          Bar, 
          XAxis, 
          YAxis, 
          CartesianGrid, 
          Tooltip, 
          ResponsiveContainer }   from 'recharts';
import {  AgGridReact         }   from "ag-grid-react";
import {  AllCommunityModule,
          ModuleRegistry      }   from 'ag-grid-community';
import {  AG_GRID_LOCALE_BR   }   from '@ag-grid-community/locale';     
import {  DisplayGridDatetime,
          DateToString        }   from "components/Date/date";     
import {  DateFromIsoString   }   from "components/Date/date";
import {  InputGeneral        }   from "components/Field/field";
import {  GetLabel, 
          GetAppLang,
          getFileTmpSrc,
          toSafeFilename      }   from "Utilities/utils";  
import {  useToastMessage     }   from "components/Covers/toastMessage";     

let appLang = null;

const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};

const Chart = React.memo(({...other}) => {
    const { chartData }   = other;
    useEffect(() => {}, [chartData]);

    return (
        chartData && (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart 
                data={chartData}
                barGap={1}
                barCategoryGap={"15%"}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey={GetLabel(appLang, 32)}>
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
        )
    );

});

const Grid = ({...other}) => {
  const { gridData                    } = other;
  const [ searchText,  setSearchText  ] = useState('');      // Searched text state
  const [ columnDefs,  setcolumnDefs  ] = useState([]);      // State of columns def
  const   gridRef                       = useRef();
  const { showToastMessage            } = useToastMessage();   // Toast message display

  ModuleRegistry.registerModules([AllCommunityModule]);
  
  const gridOptions = {
      pagination: true, // Enable pagination
      paginationPageSize: 20, // Number of rows per page
      localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
      suppressHorizontalScroll: false,
      embedFullWidthRows: true,
      groupSuppressBlankHeader: false,
      enableCellTextSelection: true,
  };
  const onQuickFilterChanged = (e) => {
      setSearchText(e.target.value);
  };
  const DateLabel = ({...other}) => {
      const { status, 
              dt0, 
              dt1 } = other;
      let c         = dayjs();
      let i         = DateFromIsoString(dt0);
      let f         = DateFromIsoString(dt1);
      let style     = [MainStyle.border, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center, MainStyle.rounded_3];
      let bgColor   = "";
      let label     = "";

      if (status === 3) {
          style.push(MainStyle.text_white);
          label   = GetLabel(appLang, 29);
          bgColor = "#cf2e2e";
      }
      else if (status === 5) {
          style.push(MainStyle.text_black);
          label = GetLabel(appLang, 97);
          bgColor = "#abb8c3";
      }
      else {
          if ((c > i) && (c < f)) {
              style.push(MainStyle.bg_warning, MainStyle.text_black);
              label = GetLabel(appLang, 40);
              
          }
          else if ((c > i) && (c > f)) {
              style.push(MainStyle.text_white);
              label = GetLabel(appLang, 98);
              bgColor = "#0062A4";
          }
          else {
              style.push(MainStyle.text_white);
              label = GetLabel(appLang, 99);
              bgColor = "#0062A4";
          }
      }
      return (
          <div style={{width: '5.0rem', backgroundColor: bgColor}} className={style.join(" ")}>
              <span className={[MainStyle.fs_7, MainStyle.p_1].join(" ")}>
                  {label}
              </span>
          </div>
      );
  };  
  const CopyPath = (props) => {
    return(
        <div 
            onClick={() => {                    
                navigator.clipboard.writeText(`${window.location.origin}/s/${props.data.ORDER_CODE}`);
                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 502) });
            }}
            className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 448 512"
                className={[MainStyle.small_ico_generic].join(" ")}
            >
                <path d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"/>
            </svg>
        </div>
    );
  };
  const DownLoadFileItem = (props) => {
    return(
        <>
            <a  href={getFileTmpSrc(props.data.FILE_DATA)}  download={`${toSafeFilename(props.data.ORDER_DESC)}.pptx`}>
                <div className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                    </svg>
                </div>
            </a>
        </>
    );
  };
  
  const defaultCol = [
    { headerName: GetLabel(appLang, 36),      field: "ORDER_DESC"   ,filter: true , flex: 0, width: 500, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    {
      headerName: GetLabel(appLang, 37),
      field: 'OPENING',
      filter: false,
      flex: 0,
      width: 100,
      cellRenderer: (params) => {
        return (
          <DateLabel
            status={params.data?.STATUS_ID}
            dt0={params.data?.OPENING}
            dt1={params.data?.CLOSING}
          />
        );
      },
      cellClass: [MainStyle.table_text_center].join(" "), 
      headerClass: MainStyle.table_header_center,
      flex: 0,
    },    
    { headerName: GetLabel(appLang, 501),     field: 'ORDER_CODE'   ,cellRenderer: CopyPath,  width: 150, cellClass: [MainStyle.table_text_center].join(" "), headerClass: MainStyle.table_header_center, flex: 0,},      
    { headerName: GetLabel(appLang, 499),     field: 'FILE_DATA'    ,cellRenderer: DownLoadFileItem, width: 100, cellClass: [MainStyle.table_text_center].join(" "), headerClass: MainStyle.table_header_center, flex: 0,},    
    { headerName: GetLabel(appLang, 38),      field: "OPENING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    { headerName: GetLabel(appLang, 39),      field: "CLOSING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,    
    { headerName: GetLabel(appLang, 35),      field: "ORDER_CODE"   ,filter: true , flex: 1, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    { headerName: GetLabel(appLang, 34),      field: "ORDER_ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}     ,
  ].filter(Boolean);

  useEffect(() => {
    if (gridData) {
      setcolumnDefs(defaultCol);
    }
  },[gridData]);

  return (
    <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
      <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_9}></div>
            <div className={MainStyle.col_lg_3}>
                <div className={[MainStyle.d_flex].join(" ")}>
                    <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 512 512"
                            className={MainStyle.small_ico_search_bar}
                        >
                            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                        </svg>
                    </div>
                    <InputGeneral 
                        value={searchText}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                        onChange={onQuickFilterChanged}
                        placeholder={GetLabel(appLang, 33)}
                    />
                </div>
            </div>
        </div>
      </div>
      <div style={{ height: '30rem'}}>
        <AgGridReact 
            ref={gridRef}
            rowData={gridData}
            columnDefs={columnDefs}
            gridOptions={gridOptions}
            quickFilterText={searchText}
        />
      </div>
    </div>
  );
};

export const MainContent = () => {
  const [ content,    setContent    ] = useState(null);
  const [ chartData,  setChartData  ] = useState(null);
  //const audioRef                      = useRef(null);
  const [loading,     setLoading    ] = useState(true);

  useEffect(() => {
      const fetchData = async () => {
        try {
          let data = await getHomeData();
          if (data) {
              if (data?.status?.statusCode == 0) {
                  data = data.response.content;
                  if (data?.RESTRICT === false) {
                      let dataset = {prev: 0, rdyv: 0, clov: 0};
                      for (let i = 0; i < data.RESULT_LIST.length; i++) {
                          if (data.RESULT_LIST[i].STATUS_ID === 4) {
                            dataset.rdyv += 1;
                          }
                          else {
                            dataset.clov += 1;
                          }
                      }
                      setContent(data);
                      setChartData([ 
                                    {name: GetLabel(appLang, 30), [GetLabel(appLang, 32)] : dataset.rdyv, fill: '#0062A4' }, 
                                    {name: GetLabel(appLang, 31), [GetLabel(appLang, 32)] : dataset.clov, fill: '#abb8c3' }
                                  ]);
                  }
                  else {
                    setContent(data);
                  }
                  setLoading(false);
              }
              else {
              }
          }
        }
        catch(err) {          
          console.error(err);
        }
      };
      fetchData();
  }, []);

  /*

  const handleInteraction = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.muted = false;
      audio.play().catch((err) => {
        console.warn('Autoplay failed:', err);
      });
    }
    window.removeEventListener('click', handleInteraction);
  };

  useEffect(() => {
    const audio = audioRef.current;
    const handleCanPlay = () => {
      if (content?.RESTRICT === true) {
        window.addEventListener('click', handleInteraction);
      }
    };
    audio?.addEventListener('canplaythrough', handleCanPlay);
    return () => audio?.removeEventListener('canplaythrough', handleCanPlay);
  }, [content]);

  */

  return (
    <React.Fragment>
      {loading && (
        <>
            <DefaultPadding/>
            <div className={MainStyle.row}>
              <div className={MainStyle.col_12}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle, MainStyle.py_1].join(" ")}>
                  <div className={[MainStyle.small_loading_circle].join(" ")}></div>
                </div>
              </div>
            </div>
        </>
      )}
      {content && (
        content?.RESTRICT === false ? 
          <React.Fragment>
            <div className={MainStyle.m_3}>
              <p className={[MainStyle.fs_3, MainStyle.p_1, MainStyle.text_body].join(" ")}>
                {`${GetLabel(appLang, 28)}`}
              </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
                <span className={[MainStyle.fs_4, MainStyle.p_1, MainStyle.text_body].join(" ")}>
                    {`${GetLabel(appLang, 585)}`}
                </span>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.mt_5, MainStyle.mb_2].join(" ")}>
              <span className={[MainStyle.fs_4, MainStyle.p_1, MainStyle.text_body].join(" ")}>
                {`${GetLabel(appLang, 584)}`}
              </span>                      
            </div>             
            <div className={MainStyle.mx_3}>
              <div className={MainStyle.row}>
                  <div className={MainStyle.col_lg}>
                    <div style={{height: '100%'}}>
                      <Grid gridData={content.RESULT_LIST}/>
                      <DefaultPadding/>
                    </div>
                  </div>
              </div>
            </div>
            {/*
              <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                <div style={{ width: '97%', height: '25rem'}}>
                        <Chart chartData={chartData} />
                </div>
              </div>  
            */}            
          </React.Fragment>
        :
          <React.Fragment>
            {/*<audio ref={audioRef} src={`${window.location.origin}/media/media_song_00.mp3`} type="audio/mp3" autoPlay loop hidden muted/>*/}
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.text_wrap].join(" ")}>
              <div className={[MainStyle.text_center, MainStyle.fs_5, MainStyle.p_1, MainStyle.text_body, MainStyle.mx_3].join(" ")}>
                <p>
                    {GetLabel(appLang, 100)}
                </p>
              </div>
            </div>
            {[...Array(3)].map((_, index) => (
              <DefaultPadding key={index} />
            ))}
            {
            /*Solicitaram tirar essa parte
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
              <div className={MainStyle.clock}>
                <div className={[MainStyle.hand, MainStyle.hour].join(" ")}></div>
                <div className={[MainStyle.hand, MainStyle.minute].join(" ")}></div>
                <div className={[MainStyle.hand, MainStyle.second].join(" ")}></div>
              </div>
            </div>
            */
            }
          </React.Fragment>
        
      )}
    </React.Fragment>
  );
};